import axios from "axios";
import { get } from "lodash";
import docCookies from "../helpers/cookies";
import { store } from "../store";

export default () => {
  // baseURL: "/backend/public/api",
  // baseURL: "/v1/dist/backend/public/api",
  const ajax = axios.create({
    baseURL: "/backend/public/api",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });

  /*
   * REQUEST
   * The interceptor here ensures that we check for the token in local storage every time an ajax request is made
   */
  ajax.interceptors.request.use(
    (config) => {
      // get in cookie stored token
      const token = docCookies.getItem("token");

      // if there is token stored in cookies on local pc, insert it in header
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }

      return config;
    },

    (error) => {
      return Promise.reject(error);
    }
  );

  /*
   * RESPONSEs
   * The interceptor here ensures that we check for the token in local storage every time an ajax request is made
   */
  ajax.interceptors.response.use(
    function (response) {
      // get the response header, check if the 'bearer' token exist,
      // if exist, it has been refreshed, update client cookies
      const newToken = get(response, "headers.authorization", null);

      // extend token cookie
      if (newToken) {
        console.log("it has new token");

        // 'bearer 29318138dsd08x' -> we need '29318138dsd08x'
        let newToken = newToken.split(" ")[1] || null;

        // update cookies
        docCookies.setItem("token", newToken, 172800, "/"); // 48h
        // docCookies.setItem("token", newToken, 86400, "/"); // 24h
      }

      //return response
      return response;
    },
    function (error) {
      // handle the backend response
      switch (error.response.status) {
        // if backend response is 401
        case 401:
          // catch requested route, to redirect it later when the login pass
          localStorage.setItem("requestedURL", window.location.pathname);

          // store.dispatch("account/logout");
          store.commit("account/logout"); // only client side
          return Promise.reject(error.response);

        default:
          return Promise.reject(error.response);
      }
    }
  );

  return ajax;
};
